import axios from 'axios'
import authStore from '../store/authStore'

class PythonApi {
  source: any; 
  getRequestInProgress: any
  client: any
  baseUrl: string
  
  constructor() {
    this.baseUrl = process.env.REACT_APP_PYTHON_API_URL || 'http://localhost:8005'
    this.client = axios.create()

    this.client.interceptors.request.use((config: any) => {
      if (authStore.token) {
        config.headers["Authorization"] = `Bearer ${authStore.token}`;
        config.headers = config.headers || {};
      }
      return config;
    });

    this.client.interceptors.response.use(
        (response: any) => response,
        this.errorResponseHandler
    )
  }

  errorResponseHandler = (error: any) => {
    const status = Number(error?.response?.status ?? error?.request?.status ?? 0)
    const requestUrl = String(error?.config?.url || '')
    const isPythonRequest = requestUrl.startsWith(this.baseUrl)
    const isNetworkError = error?.message === 'Network Error' || error?.code === 'ERR_NETWORK'
    const hasAuth = Boolean(authStore.token)

    if (status === 401 || (isPythonRequest && isNetworkError && hasAuth)) {
      authStore.signOut()
      window.location.href="/login";
    }
    return Promise.reject(error);
  }

  post = async (url: string, data?: any, config?: any) => {
    try {
      let res = await this.client.post(this.baseUrl + url, data, config)
      return res
    } catch (error) {
      throw this.formatError(error)
    }
  }

  get = async (url: string, config?: any) => {
    try {
      let res = await this.client.get(this.baseUrl + url, config)
      return res
    } catch (error) {
      throw this.formatError(error)
    }
  }

  put = async (url: string, data: any, config?: any) => {
    try {
      let res = await this.client.put(this.baseUrl + url, data, config)
      return res
    } catch (error) {
      throw this.formatError(error)
    }
  }

  delete = async (url: string, config?: any) => {
    try {
      let res = await this.client.delete(this.baseUrl + url, config)
      return res
    } catch (error) {
      throw this.formatError(error)
    }
  }

  formatError(error: any) {
    if (
      error?.code === 'ERR_CANCELED' ||
      error?.name === 'AbortError' ||
      (typeof axios.isCancel === 'function' && axios.isCancel(error))
    ) {
      return error
    }
    if (!error.response) {
      error.response = {
        data: {
          message: "Something went wrong, Please try again later"
        }
      }
    }
    return error
  }
}

const pythonApi = new PythonApi()

export default pythonApi
